import { useContext, useState, useEffect } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Options from './Options';
import Widget from './Widget';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { ProductUIStyles } from '../StepTwo/ProductUIStyles';
import {
  COLOR1,
  INTEREST_WITH_HOLD,
  INTEREST_WITH_HOLD_QUESTION,
  INTEREST_WITH_HOLD_TEXT,
} from '../../../constants';
import MultiCountrySelect from './MultiCountrySelect';
import CustomTooltip from '../../Tooltip/CustomTooltip';
import { businessMapping } from '../../../services/businessMapping';
import { productMapping } from '../../../services/productMapping';
import { isBundle } from '../../commonCode';

function Question({
  setItemsAnswer,
  parent,
  question,
  answerHandler,
  itemsAnswer,
  disable,
  subQuestion,
  isBundleCompliance = false,
}) {
  const leadGenerationContext = useContext(LeadGenerationContext);
  const classes = ProductUIStyles(leadGenerationContext?.theme);
  const { productName, theme } = leadGenerationContext;

  const { t } = useTranslation();
  const [translation, setTranslation] = useState(leadGenerationContext.productQuestionsEN);
  useEffect(() => {
    if (leadGenerationContext.language === 'EN') {
      setTranslation(leadGenerationContext.productQuestionsEN);
    }
    if (leadGenerationContext.language === 'ES') {
      setTranslation(leadGenerationContext.productQuestionsES);
    }
  }, [leadGenerationContext.language]);

  if (question.type === 'Knockout') {
    return (
      <Grid container>
        <Grid container size={{ xs: 12 }}>
          {question.widget && (
            <Widget
              question={question}
              disable={false}
              answerHandler={answerHandler}
              itemsAnswer={itemsAnswer}
              isBundleCompliance={isBundleCompliance}
            />
          )}
          {question.next.length > 0 &&
            question.next[0].components &&
            question.next[0].components.length > 0 && (
              <Options components={question.next[0].components} />
            )}
        </Grid>
      </Grid>
    );
  }

  if (question.type === 'Form' && question.name !== 'InternationalWireTransfer') {
    return (
      <>
        <Grid container>
          {question.widget && (
            <Widget
              question={question}
              disable={disable}
              answerHandler={answerHandler}
              itemsAnswer={itemsAnswer}
            />
          )}
        </Grid>
        <Grid container className="options">
          {question.next.length > 0 &&
            question.next[0].components &&
            question.next[0].components.length > 0 && (
              <Options
                parent={parent}
                itemsAnswer={itemsAnswer}
                question={question}
                components={question.next[0].components}
              />
            )}
        </Grid>
      </>
    );
  }
  if (question.type === 'Form' && question.name === 'InternationalWireTransfer') {
    return (
      <>
        <Grid container>
          <Grid>
            {question.widget && (
              <Widget
                question={question}
                disable={disable}
                answerHandler={answerHandler}
                itemsAnswer={itemsAnswer}
              />
            )}
          </Grid>
        </Grid>
        <Grid container className="options">
          {question.next.length > 0 &&
            question.next[0].components &&
            question.next[0].components.length > 0 && (
              <Options
                parent={parent}
                itemsAnswer={itemsAnswer}
                question={question}
                components={question.next[0].components}
              />
            )}
        </Grid>
        <Grid container>
          <Grid
            size={{ xs: 12, md: 8, sm: 12, lg: 7 }}
            sx={
              isBundle(productName)
                ? {
                    padding: 0,
                  }
                : classes.group_sub_select
            }
          >
            {itemsAnswer.InternationalWireTransfer &&
              businessMapping(leadGenerationContext.productName) && (
                <>
                  <MultiCountrySelect />
                  <span
                    style={{
                      margin: '10px 0 0px 0',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <span
                      style={{
                        marginRight: '6px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <CustomTooltip custom />
                    </span>
                    <Typography sx={classes.multiCountryDesc}>
                      {t('Select max of 10 countries', {
                        defaultValue: 'Select max of 10 countries',
                      })}
                    </Typography>
                  </span>
                </>
              )}
          </Grid>
        </Grid>
      </>
    );
  }
  if (question.type === 'IRA') {
    return (
      <Grid container className="options">
        {question.next.length > 0 &&
          question.next[0].components &&
          question.next[0].components.length > 0 && (
            <Options
              setItemsAnswer={setItemsAnswer}
              parent={parent}
              itemsAnswer={itemsAnswer}
              question={question}
              components={question.next[0].components}
            />
          )}
      </Grid>
    );
  }
  if (question.type === 'Interest') {
    return (
      <Grid
        container
        role="application"
        aria-labelledby="WithholdTextId"
        aria-describedby="WithholdTextId1"
      >
        <Grid size={{ xs: 12 }} sx={classes.titleborder}>
          <Box
            component="span"
            id="WithholdTextId"
            sx={
              isBundle(productName)
                ? {
                    fontSize: '16px',
                    fontWeight: 700,
                    margin: '20px  0 10px 0',
                    fontFamily: 'TTNORMSPROBOLD',
                  }
                : classes.quesTitleStyle
            }
            style={{ marginRight: '5px' }}
            aria-label={t('Interest Withholding Setup', {
              defaultValue: 'Interest Withholding Setup',
            })}
          >
            {isBundle(productName)
              ? t('Interest Withholding on your Ahorra Account', {
                  defaultValue: 'Interest Withholding on your Ahorra Account',
                })
              : productMapping(leadGenerationContext.productName) === 'Elite Account' ||
                productMapping(leadGenerationContext.productName) === 'Libre' ||
                productMapping(leadGenerationContext.productName) === 'Ahorra'
              ? t('Interest Withholding Setup Prog', {
                  defaultValue: 'Interest Withholding Setup',
                })
              : t('Interest Withholding Setup', {
                  defaultValue: 'Interest Withholding Setup',
                })}
          </Box>

          <CustomTooltip
            customAriaLabel={`${t(INTEREST_WITH_HOLD, {
              defaultValue: INTEREST_WITH_HOLD,
            })}`}
            placement="right"
            text={t('Interest Withholding Tooltip', {
              defaultValue: INTEREST_WITH_HOLD_TEXT,
            })}
            tabIndex={0}
          />
        </Grid>
        <Grid size={{ xs: 12 }} style={{ marginTop: '20px' }}>
          <Box
            component="span"
            id="WithholdTextId1"
            sx={{ ...classes.quesTitleSubHeadingStyle, color: theme?.palette?.primary?.main }}
            aria-label={t('WithholdText', {
              defaultValue: INTEREST_WITH_HOLD_QUESTION,
            })}
          >
            {isBundle(productName)
              ? t('Do you want Oriental Bank to withhold interest on your Ahorra account?', {
                  defaultValue:
                    'Do you want Oriental Bank to withhold interest on your Ahorra account?',
                })
              : productMapping(leadGenerationContext.productName) === 'Elite Account' ||
                productMapping(leadGenerationContext.productName) === 'Libre' ||
                productMapping(leadGenerationContext.productName) === 'Ahorra'
              ? t('WithholdTextProg', {
                  defaultValue:
                    'Do you wish Oriental Bank to withhold interest for this account? If so, select the option included below.',
                })
              : t('WithholdText', {
                  defaultValue:
                    'Do you wish Oriental Bank to withhold interest for this account? If so select the option included below.',
                })}
          </Box>

          <br />
        </Grid>
      </Grid>
    );
  }
  const asterikIfQuestionReq = () => (question.required ? ' *' : '');

  return (
    <Grid container>
      <Grid size={{ xs: 12 }}>
        {subQuestion ? (
          <span aria-label={translation[question.questionDesc]}>
            {translation[question.questionDesc]}
            <Box component="span" sx={classes.star_style}>
              {asterikIfQuestionReq()}
            </Box>
          </span>
        ) : (
          <span
            style={{
              font: 'normal normal bold 14px/17px Arial',
              letterSpacing: '0.1px',
              color: theme?.palette?.primary?.main,
            }}
            aria-label={translation[question.questionDesc]}
          >
            {translation[question.questionDesc]}
            <Box component="span" sx={classes.star_style}>
              {asterikIfQuestionReq()}
            </Box>
          </span>
        )}
      </Grid>
      <Grid size={{ xs: 12 }} style={{ display: 'flex', width: '42%', alignItems: 'center' }}>
        {question.widget && (
          <Widget
            question={question}
            disable={disable}
            answerHandler={answerHandler}
            itemsAnswer={itemsAnswer}
          />
        )}
        {question.next.length > 0 &&
          question.next[0].components &&
          question.next[0].components.length > 0 && (
            <Options components={question.next[0].components} />
          )}
      </Grid>
    </Grid>
  );
}

Question.propTypes = {
  setItemsAnswer: PropTypes.func,
  parent: PropTypes.string,
  question: PropTypes.object,
  answerHandler: PropTypes.func,
  itemsAnswer: PropTypes.object,
  disable: PropTypes.bool,
  subQuestion: PropTypes.bool,
  isBundleCompliance: PropTypes.bool,
};
export default Question;
